import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { SymantecSES } from "@graylog/enterprise-api";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import formValidation from "../common/utils/formValidation";
import ValidatedInput from "../common/ValidatedInput";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const region = [
    { label: t("symantecses.authorize.region_na"), value: "https://api.sep.securitycloud.symantec.com" },
    { label: t("symantecses.authorize.region_eu"), value: "https://api.sep.eu.securitycloud.symantec.com" },
    { label: t("symantecses.authorize.region_in"), value: "https://api.sep.in.securitycloud.symantec.com" }
  ];
  const { connectionString } = formData;
  const [formValidated, setFormValidated] = useState("");
  const fieldChange = (event) => {
    if (event) {
      setFormValidated(event.target.value);
    }
    onChange(event, null);
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    var _a, _b;
    setLoading(true);
    const fetcher = SymantecSES.checkCredentials({
      oauth_credentials: ((_a = formData == null ? void 0 : formData.oauthCredentials) == null ? void 0 : _a.value) || "",
      ses_base_url: ((_b = formData == null ? void 0 : formData.sesBaseURL) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("symantecses.authorize.connection_error")
        });
      }
      setLoading(false);
    }).catch((err) => {
      setLoading(false);
      setFormError({
        full_message: err.message,
        nice_message: t("symantecses.authorize.connection_error")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["symantecSESName", "oauthCredentials", "sesBaseURL"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      loading,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "symantecSESName",
        type: "text",
        fieldData: formData.symantecSESName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: connectionString == null ? void 0 : connectionString.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "oauthCredentials",
        type: "password",
        onChange,
        fieldData: formData.oauthCredentials,
        label: t("symantecses.authorize.oauth_credentials"),
        help: t("symantecses.authorize.oauth_credentials_help"),
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "sesBaseURL",
        onChange: (e) => fieldChange(e),
        fieldData: formData.sesBaseURL,
        help: t("symantecses.authorize.hosting_location_help"),
        required: true,
        label: t("symantecses.authorize.hosting_location")
      },
      renderOptions(region, t("symantecses.authorize.choose_location"), false)
    ),
    /* @__PURE__ */ React.createElement("p", null, formValidated && t("symantecses.authorize.cloud_base_url", { url: formValidated }))
  );
};
export default StepAuthorize;
